import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"tw-flex tw-mb-4 tw-border-l-4 tw-border-red-500 tw-p-3 tw-bg-red-200 tw-rounded-md\"><div class=\"tw-flex tw-items-center\"><i class=\"fas fa-bell-slash tw-text-2xl tw-text-red-500\"></i></div><p class=\"tw-ml-3 tw-text-red-500\"> Questo browser non supporta le notifiche, utilizza uno tra <a href=\"https://www.google.com/intl/it_it/chrome/\" target=\"_blank\" class=\"underline\">Chrome</a>, <a href=\"https://www.mozilla.org/it/firefox/new/\" target=\"_blank\" class=\"underline\">Firefox</a> o <a href=\"https://www.microsoft.com/it-it/edge\" target=\"_blank\" class=\"underline\">Edge</a></p></div>", 1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 2 }
const _hoisted_6 = ["disabled", "checked", "indeterminate"]
const _hoisted_7 = {
  for: "notification-permissions",
  class: "tw-ml-3"
}
const _hoisted_8 = {
  key: 0,
  class: "tw-flex tw-mt-4 tw-border-l-4 tw-border-red-500 tw-p-3 tw-bg-red-200 tw-rounded-md"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bell-slash tw-text-2xl tw-text-red-500" })
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "tw-ml-3 tw-text-red-500" }, [
  /*#__PURE__*/_createTextVNode(" Permesso alle notifiche negato! Per scoprire come attivarle, apri il "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "underline"
  }, "centro assistenza")
], -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "tw-flex tw-flex-col tw-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle tw-text-warning tw-text-5xl" }),
  /*#__PURE__*/_createElementVNode("p", { class: "tw-text-warning tw-font-bold tw-text-2xl tw-text-center" }, "Attenzione")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "tw-mx-3 tw-mt-2 tw-text-center" }, " Effettuare il login senza attivare le notifiche non ti permetterà di usufruire di tutte le potenzialità di Amministro.io ", -1)
const _hoisted_14 = { class: "tw-flex tw-flex-wrap tw-justify-between tw-pt-4 tw-w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_shared_modal = _resolveComponent("shared-modal")!

  return (_ctx.showUnsupported === null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : (_ctx.showUnsupported)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("input", {
            type: "checkbox",
            name: "notification-permissions",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.askForNotifications && _ctx.askForNotifications(...args)), ["prevent"])),
            disabled: _ctx.notificationStatus !== 'default' || _ctx.disabled,
            checked: _ctx.notificationStatus === 'granted',
            indeterminate: _ctx.notificationStatus === 'denied',
            style: {"transform":"scale(1.2)"}
          }, null, 8, _hoisted_6),
          _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.notificationStatus === "granted"
          ? "Notifiche abilitate"
          : _ctx.notificationStatus === "denied"
          ? "Notifiche disabilitate"
          : "Abilita le notifiche per un servizio migliore"), 1),
          (_ctx.notificationStatus === 'denied')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11))
            : _createCommentVNode("", true),
          _createVNode(_component_shared_modal, {
            isOpen: _ctx.isOpen,
            "onUpdate:isOpen": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isOpen) = $event))
          }, {
            content: _withCtx(() => [
              _hoisted_12,
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  shape: "outlined",
                  class: "tw-w-full tw-m-2 tw-order-last",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.proceed && _ctx.proceed(...args)), ["stop"]))
                }, "Accedi comunque"),
                _createElementVNode("button", {
                  shape: "default",
                  class: "tw-w-full tw-m-2 tw-bg-primary-light",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.askForNotificationsAndProceed && _ctx.askForNotificationsAndProceed(...args)), ["stop"]))
                }, "Abilita")
              ])
            ]),
            _: 1
          }, 8, ["isOpen"])
        ]))
}